import _ from 'lodash';

interface CleanProgram {
  id: number;
  programId: number;
  level: number;
  name: string;
  programName: string;
  unitType: string;
}

// 20230802144709
// https://apiqa.scouting.org/lookups/advancements/ranks
const LOOKUP = _.chain([
  {
    id: '1',
    name: 'Scout',
    level: '1',
    programId: '2',
    programName: 'Scouts BSA',
    unitType: 'Troop',
  },
  {
    id: '2',
    name: 'Tenderfoot',
    level: '2',
    programId: '2',
    programName: 'Scouts BSA',
    unitType: 'Troop',
  },
  {
    id: '3',
    name: 'Second Class',
    level: '3',
    programId: '2',
    programName: 'Scouts BSA',
    unitType: 'Troop',
  },
  {
    id: '4',
    name: 'First Class',
    level: '4',
    programId: '2',
    programName: 'Scouts BSA',
    unitType: 'Troop',
  },
  {
    id: '5',
    name: 'Star Scout',
    level: '5',
    programId: '2',
    programName: 'Scouts BSA',
    unitType: 'Troop',
  },
  {
    id: '6',
    name: 'Life Scout',
    level: '6',
    programId: '2',
    programName: 'Scouts BSA',
    unitType: 'Troop',
  },
  {
    id: '7',
    name: 'Eagle Scout',
    level: '7',
    programId: '2',
    programName: 'Scouts BSA',
    unitType: 'Troop',
  },
  {
    id: '8',
    name: 'Tiger',
    level: '2',
    programId: '1',
    programName: 'Cub Scouting',
    unitType: 'Pack',
  },
  {
    id: '9',
    name: 'Wolf',
    level: '3',
    programId: '1',
    programName: 'Cub Scouting',
    unitType: 'Pack',
  },
  {
    id: '10',
    name: 'Bear',
    level: '4',
    programId: '1',
    programName: 'Cub Scouting',
    unitType: 'Pack',
  },
  {
    id: '11',
    name: 'Webelos',
    level: '5',
    programId: '1',
    programName: 'Cub Scouting',
    unitType: 'Pack',
  },
  {
    id: '12',
    name: 'Arrow of Light',
    level: '6',
    programId: '1',
    programName: 'Cub Scouting',
    unitType: 'Pack',
  },
  {
    id: '13',
    name: 'Bobcat',
    level: '1',
    programId: '1',
    programName: 'Cub Scouting',
    unitType: 'Pack',
  },
  {
    id: '14',
    name: 'Lion',
    level: '0',
    programId: '1',
    programName: 'Cub Scouting',
    unitType: 'Pack',
  },
  {
    id: '15',
    name: 'Apprentice',
    level: '1',
    programId: '5',
    programName: 'Sea Scouting',
    unitType: 'Ship',
  },
  {
    id: '16',
    name: 'Ordinary',
    level: '2',
    programId: '5',
    programName: 'Sea Scouting',
    unitType: 'Ship',
  },
  {
    id: '17',
    name: 'Able',
    level: '3',
    programId: '5',
    programName: 'Sea Scouting',
    unitType: 'Ship',
  },
  {
    id: '18',
    name: 'Quartermaster',
    level: '4',
    programId: '5',
    programName: 'Sea Scouting',
    unitType: 'Ship',
  },
  {
    id: '19',
    name: 'Venturing',
    level: '1',
    programId: '4',
    programName: 'Venturing',
    unitType: 'Crew',
  },
  {
    id: '20',
    name: 'Discovery',
    level: '2',
    programId: '4',
    programName: 'Venturing',
    unitType: 'Crew',
  },
  {
    id: '21',
    name: 'Pathfinder',
    level: '3',
    programId: '4',
    programName: 'Venturing',
    unitType: 'Crew',
  },
  {
    id: '22',
    name: 'Summit',
    level: '4',
    programId: '4',
    programName: 'Venturing',
    unitType: 'Crew',
  },
]).map(item => ({
  ...item,
  id: Number(item.id),
  programId: Number(item.programId),
  level: Number(item.level),
}));

export class RankModel {
  programId: number;
  rankId: number;
  id: number;
  programRanks: CleanProgram[] = [];
  level: number;
  name: string;
  unitType: string;

  constructor(programId: number, rankId: number) {
    this.programId = Number(programId);
    this.rankId = Number(rankId);
    this.id = Number(rankId);

    this.programRanks = LOOKUP.filter(rank => rank.programId === this.programId)
      .sortBy(['level'])
      .value();

    const rankInfo = this.programRanks.find(rank => rank.id === this.rankId);
    if (!rankInfo) {
      throw new Error(`No rank found for id ${rankId}`);
    }

    this.level = rankInfo.level;
    this.name = rankInfo.name;
    this.unitType = rankInfo.unitType;
  }

  static getProgramIdForRank(rankId: number) {
    const rank = LOOKUP.find(item => item.id === rankId).value();

    if (!rank) return;

    return rank.programId;
  }

  static getRankName(rankId: number) {
    const rank = LOOKUP.find(item => item.id === rankId).value();
    return rank?.name;
  }

  getFirstProgramRank() {
    const firstRank = _.first(this.programRanks);
    const rank = new RankModel(
      firstRank?.programId as number,
      firstRank?.id as number,
    );
    return rank;
  }
  getLastProgramRank() {
    const lastRank = _.last(this.programRanks);
    const rank = new RankModel(
      lastRank?.programId as number,
      lastRank?.id as number,
    );
    return rank;
  }

  isFirstOfProgram() {
    const firstRank = this.getFirstProgramRank();
    return (
      this.rankId === firstRank.id && this.programId === firstRank.programId
    );
  }
  isLastOfProgram() {
    const lastRank = this.getLastProgramRank();
    return this.rankId === lastRank.id && this.programId === lastRank.programId;
  }

  getPreviousRank() {
    const result = this.programRanks.find(
      rank => rank.level === this.level - 1,
    );

    return result
      ? new RankModel(result.programId, result.id)
      : this.getFirstProgramRank();
  }

  getNextRank() {
    const result = this.programRanks.find(
      rank => rank.level === this.level + 1,
    );

    return result
      ? new RankModel(result.programId, result.id)
      : this.getLastProgramRank();
  }
}
